import { AuthResponseModel } from "./AuthResponse";
import { BeeResponseModel } from "./BeeResponseModel";
import { LocalizationResponseModel } from "./LocalizationResponseModel";
import values from "lodash/values";
import { UserResponseModel } from "./UserResponseModel";
export var ResponseTypeEnum;
(function (ResponseTypeEnum) {
    ResponseTypeEnum["ENTITIES"] = "entities";
    ResponseTypeEnum["WAITLIST_ENTITIES"] = "waitlist_entities";
    ResponseTypeEnum["OPTIONS"] = "options";
    ResponseTypeEnum["LOCALIZATION"] = "localization";
    ResponseTypeEnum["FLASH_NOTIFICATIONS"] = "flash_notifications";
    ResponseTypeEnum["FORM_DATA"] = "form_data";
    ResponseTypeEnum["REDIRECT"] = "redirect";
    ResponseTypeEnum["DOWNLOAD"] = "download";
    ResponseTypeEnum["DISCOUNT_STATUS"] = "discount_status";
    ResponseTypeEnum["FIELD_VALIDATION_ERRORS"] = "field_validation_errors";
    ResponseTypeEnum["BILLS"] = "bills";
    ResponseTypeEnum["BILL_POSITIONS"] = "bill_positions";
    ResponseTypeEnum["PAYMENT_GATEWAY_CONFIGS"] = "payment_gatway_configs";
    ResponseTypeEnum["BANK_TRANSFER_DETAILS"] = "bank_transfer_details";
    ResponseTypeEnum["FALLBACK_ERROR_MESSAGE"] = "fallback_error_message";
    ResponseTypeEnum["OUTGOING_MESSAGES"] = "outgoing_messages_response";
    ResponseTypeEnum["CUSTOMER_DATA"] = "customerData";
    ResponseTypeEnum["ADMIN_BOOKING_OPTIONS"] = "admin_booking_options_response";
    ResponseTypeEnum["CERTIFICATE_LIST"] = "certificate_list";
    ResponseTypeEnum["PAGINATION"] = "pagination";
    ResponseTypeEnum["AUTH_TOKEN"] = "auth_token";
    ResponseTypeEnum["REFRESH_TOKEN"] = "refresh_token";
    ResponseTypeEnum["REQUEST_AUTHENTICATION_LINK"] = "auth_request";
    ResponseTypeEnum["USER"] = "user";
})(ResponseTypeEnum || (ResponseTypeEnum = {}));
var BeeResponseManager = /** @class */ (function () {
    function BeeResponseManager(modelTypes, response) {
        this.modelTypes = modelTypes;
        this.response = response;
        this.models = {};
        this.localization();
    }
    Object.defineProperty(BeeResponseManager.prototype, "name", {
        get: function () {
            var _a;
            return ((_a = this.response) === null || _a === void 0 ? void 0 : _a.name) || null;
        },
        enumerable: false,
        configurable: true
    });
    ;
    BeeResponseManager.prototype.entities = function () {
        return this.getResponseData(ResponseTypeEnum.ENTITIES);
    };
    BeeResponseManager.prototype.options = function () {
        return this.getResponseData(ResponseTypeEnum.OPTIONS);
    };
    BeeResponseManager.prototype.localization = function () {
        return this.getResponseData(ResponseTypeEnum.LOCALIZATION);
    };
    BeeResponseManager.prototype.flashNotifications = function () {
        return this.getResponseData(ResponseTypeEnum.FLASH_NOTIFICATIONS) || {};
    };
    BeeResponseManager.prototype.fieldValidationErrors = function () {
        return this.getResponseData(ResponseTypeEnum.FIELD_VALIDATION_ERRORS) || null;
    };
    BeeResponseManager.prototype.redirectUrl = function () {
        return this.getResponseData(ResponseTypeEnum.REDIRECT);
    };
    BeeResponseManager.prototype.download = function () {
        return this.getResponseData(ResponseTypeEnum.DOWNLOAD);
    };
    BeeResponseManager.prototype.bills = function () {
        return this.getResponseData(ResponseTypeEnum.BILLS);
    };
    BeeResponseManager.prototype.billPositons = function () {
        return this.getResponseData(ResponseTypeEnum.BILL_POSITIONS);
    };
    BeeResponseManager.prototype.user = function () {
        return this.get(ResponseTypeEnum.USER);
    };
    BeeResponseManager.prototype.paymentGatewayConfigs = function () {
        return this.getResponseData(ResponseTypeEnum.PAYMENT_GATEWAY_CONFIGS);
    };
    BeeResponseManager.prototype.bankTransferDetails = function () {
        return this.getResponseData(ResponseTypeEnum.BANK_TRANSFER_DETAILS);
    };
    BeeResponseManager.prototype.formData = function () {
        return this.getResponseData(ResponseTypeEnum.FORM_DATA);
    };
    BeeResponseManager.prototype.outgoingMessages = function () {
        return this.getResponseData(ResponseTypeEnum.OUTGOING_MESSAGES);
    };
    BeeResponseManager.prototype.customerData = function () {
        return this.getData();
    };
    BeeResponseManager.prototype.waitlistEntities = function () {
        return this.getResponseData(ResponseTypeEnum.WAITLIST_ENTITIES);
    };
    BeeResponseManager.prototype.discountStatus = function () {
        try {
            return this.getResponseData(ResponseTypeEnum.DISCOUNT_STATUS);
        }
        catch (_a) {
            return null;
        }
    };
    BeeResponseManager.prototype.adminBookingSettings = function () {
        return this.getResponseData(ResponseTypeEnum.ADMIN_BOOKING_OPTIONS);
    };
    BeeResponseManager.prototype.certificates = function () {
        return values(this.getData()[ResponseTypeEnum.CERTIFICATE_LIST]);
    };
    BeeResponseManager.prototype.pagination = function () {
        return this.getResponseData(ResponseTypeEnum.PAGINATION);
    };
    BeeResponseManager.prototype.getAuthResponse = function () {
        return this.get(ResponseTypeEnum.AUTH_TOKEN);
    };
    BeeResponseManager.prototype.getRefreshResponse = function () {
        return this.get(ResponseTypeEnum.REFRESH_TOKEN);
    };
    BeeResponseManager.prototype.getSendAuthLinkResponse = function () {
        return this.get(ResponseTypeEnum.REQUEST_AUTHENTICATION_LINK);
    };
    BeeResponseManager.prototype.get = function (modelType) {
        if (this.models[modelType]) {
            return this.models[modelType];
        }
        if (!this.getData())
            return null;
        var response = this.getData()[modelType];
        this.models[modelType] = this.constructModel(response, modelType);
        return this.models[modelType];
    };
    BeeResponseManager.prototype.getResponseData = function (modelType) {
        var _a;
        return (_a = this.get(modelType)) === null || _a === void 0 ? void 0 : _a.getData();
    };
    BeeResponseManager.prototype.getData = function () {
        var _a;
        return (_a = this.response) === null || _a === void 0 ? void 0 : _a.body;
    };
    BeeResponseManager.prototype.getModelClass = function (modelType) {
        return this.modelTypes[modelType] || BeeResponseModel;
    };
    BeeResponseManager.prototype.constructModel = function (response, modelType) {
        var ModelClass = this.getModelClass(modelType);
        return new ModelClass(this, response);
    };
    return BeeResponseManager;
}());
export { BeeResponseManager };
export var getResponseManager = function (response) {
    var _a;
    var modelTypes = (_a = {},
        _a[ResponseTypeEnum.LOCALIZATION] = LocalizationResponseModel,
        _a[ResponseTypeEnum.AUTH_TOKEN] = AuthResponseModel,
        _a[ResponseTypeEnum.REFRESH_TOKEN] = AuthResponseModel,
        _a[ResponseTypeEnum.REQUEST_AUTHENTICATION_LINK] = AuthResponseModel,
        _a[ResponseTypeEnum.USER] = UserResponseModel,
        _a);
    return new BeeResponseManager(modelTypes, response);
};
